export const MODAL_NAMES = {
  MONEYOUT_REDIRECT: 'my-other-things-moneyout-modal-redirect',
}
